'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const SecondaryTitle = require('../../coupons/views/secondary-title');
const BrowseLetter = require('./browse-letter');
const BrowseMerchant = require('./browse-merchant');
const SidebarMerchant = require('../../merchant/views/sidebar-browse-merchant');
const Footer = require('../../../components/footer');

function AllBrands({ payload, deps }) {
  const {
    seoMetaData: { h1Override },
    navigationMerchants,
    popularMerchants,
    allBrandMerchants,
  } = payload;
  const { routes } = deps;

  return h('article', [
    h(Header, {
      routes,
      activePage: 'all-brands',
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: 'modules.merchant.AlphaPageHeading',
    }),
    h('section.container', [
      h('.layout', [
        h('.layout-content', [
          h(SecondaryTitle, {
            resourceKey: 'modules.merchant.AlphaPageSubHeading',
          }),
          h(BrowseLetter, { merchants: allBrandMerchants }),
          h(BrowseMerchant, { routes, merchants: allBrandMerchants }),
        ]),
        h('.layout-sidebar', [
          h(SidebarMerchant, {
            routes,
            merchants: popularMerchants,
            localisation: {
              resource: 'modules.shared.TopBrands',
              data: { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
            },
            bloodhound: 'PopularStores',
          }),
        ]),
      ]),
      Footer(),
    ]),
  ]);
}

module.exports = AllBrands;
